import React from 'react'
import { ComponentExt } from 'util/reactExt'
import { DatePicker, Radio, Table } from 'antd'
import moment from 'moment'
import styles from './index.scss'

const studyMinsFormatter = min =>
  min ? Math.round((Number(min) / 60) * 100) / 100 : 0

const percentFormatter = percent =>
  percent ? Math.round(Number(percent) * 100 * 100) / 100 : 0

const { MonthPicker } = DatePicker

const tabs = [
  { key: 'video', name: '该团队最受欢迎的视频' },
  { key: 'person', name: '每位学员学习的情况' },
]

const tabsMap = {
  video: {
    text: '',
    fetcher: 'fetchTeamPopularVideos',
    columns: [
      { title: '序号', dataIndex: 'index', className: 'columnCenter' },
      {
        title: '月份',
        dataIndex: 'the_date',
        className: 'columnCenter',
      },
      {
        title: '文章标题',
        className: 'columnCenter',
        dataIndex: 'title',
      },
      {
        title: '学习人数',
        className: 'columnCenter',
        dataIndex: 'user_count',
      },
      {
        title: '浏览次数',
        className: 'columnCenter',
        dataIndex: 'views',
      },
      {
        title: '学习时长',
        className: 'columnCenter',
        dataIndex: 'study',
      },
    ],
  },
  person: {
    text: '注：该栏目排序，默认以个人学习时长降序排列',
    fetcher: 'fetchTeamStaffData',
    columns: [
      { title: '序号', dataIndex: 'index', className: 'columnCenter' },
      {
        title: '姓名',
        dataIndex: 'staff_name',
        className: 'columnCenter',
        render: (name, row) => (
          <a
            href={`#/usercenter/data/person?staffid=${
              row.staff_id
            }&name=${name}`}
            target="_blank"
          >
            {name}
          </a>
        ),
      },
      {
        title: '总学习时长（小时）',
        className: 'columnCenter',
        dataIndex: 'study',
      },
      {
        title: '学习视频个数',
        className: 'columnCenter',
        dataIndex: 'articles',
      },
      {
        title: '视频完成度（%）',
        className: 'columnCenter',
        dataIndex: 'finish_percent',
      },
    ],
  },
}

interface ITeamMostTableProps {
  entityid?: number | string
}

class ITeamMostTable extends ComponentExt<ITeamMostTableProps> {
  state = {
    data: [],
    currentPkVol: 'video',
    pkMoment: moment(),
    date: moment().format('YYYY-MM'),
    loading: false,
  }

  componentDidMount() {
    this.fetchCurrentData(this.state.currentPkVol)
  }

  fetchTeamPopularVideos = async date => {
    const res = await this.api.user.getTeamPopularVideos(
      date,
      this.props.entityid,
    )
    const data = res.slice(0, 10).map((x, i) => ({
      ...x,
      index: i + 1,
      study: studyMinsFormatter(x.study),
    }))

    this.setState({
      data,
    })
  }

  fetchTeamStaffData = async date => {
    const res = await this.api.user.getTeamStaffData(date, this.props.entityid)
    const data = res.slice(0, 10).map((x, i) => ({
      ...x,
      index: i + 1,
      study: studyMinsFormatter(x.study),
      finish_percent: percentFormatter(x.finish_percent),
    }))

    this.setState({
      data,
    })
  }

  fetchCurrentData = async current => {
    this.setState({ loading: true, data: [] })

    try {
      await this[tabsMap[current].fetcher](this.state.date)
      this.setState({ loading: false })
    } catch {
      this.setState({ loading: false })
    }
  }

  handlePkVolChange = async e => {
    const current = e.target.value
    const date = this.state.date
    this.setState(
      {
        loading: true,
        currentPkVol: current,
      },
      () => this.fetchCurrentData(current),
    )
  }

  handleSetDate = (m, date) => {
    this.setState(
      {
        pkMoment: m,
        date,
      },
      () => this.fetchCurrentData(this.state.currentPkVol),
    )
  }

  render() {
    const { data, currentPkVol, pkMoment, loading } = this.state

    const columns = tabsMap[currentPkVol].columns
    return (
      <section className={styles.teamTable}>
        <h4 className={styles.bar}>
          <Radio.Group
            onChange={this.handlePkVolChange}
            value={currentPkVol}
            style={{ marginBottom: 8 }}
          >
            {tabs.map(t => (
              <Radio.Button key={t.key} value={t.key}>
                {t.name}
              </Radio.Button>
            ))}
          </Radio.Group>
          <MonthPicker
            placeholder={'请选择日期'}
            defaultValue={moment()}
            value={pkMoment}
            disabledDate={current =>
              (current && current > moment().endOf('day')) ||
              current < moment('2018-01-01')
            }
            onChange={(m, d) => this.handleSetDate(m, d)}
          />
        </h4>
        {tabsMap[currentPkVol].text && (
          <h5 className={styles.info}>{tabsMap[currentPkVol].text}</h5>
        )}
        <Table loading={loading} columns={columns} dataSource={data} bordered />
      </section>
    )
  }
}

export default ITeamMostTable
